import {AxiosInstance} from "axios";
import {ShowcaseItem} from "@/core/interfaces/showcase";
import {Extension, ExtensionIndexParams} from "@/core/interfaces/extension/Extension";

export default function (client: AxiosInstance) {
    return {
        /**
         * Get all extensions.
         * @returns {Promise} Promise object represents the HTTP request.
         */
        index(params: ExtensionIndexParams = {}): Promise<Extension[]> {
            return client
                .get('extensions', {params})
                .then(response => response.data.data)
                .catch(() => []);
        },
        /**
         * Get a single extension.
         *
         * @param id
         */
        read(id: number) {
            return client.get(`extensions/${id}`)
                .then(response => response.data.data);
        },

        /**
         * Get all showcases for a given extension.
         *
         * @param extensionId
         * @param abortController
         */
        async showcase(extensionId: number, abortController?: AbortController): Promise<ShowcaseItem[]> {
            return client.get(`extensions/${extensionId}/showcase`, {
                signal: abortController?.signal
            })
                .then(response => response.data.data);
        },
        /**
         * Enable an extension.
         *
         * @param extensionId
         */
        async enable(extensionId: number): Promise<void> {
            return client.patch(`extensions/${extensionId}/enable`)
                .then(response => response.data.data);
        },

        /**
         * Disable an extension.
         *
         * @param extensionId
         */
        async disable(extensionId: number): Promise<void> {
            return client.patch(`extensions/${extensionId}/disable`)
                .then(response => response.data.data);
        },

        /**
         * Record that the pharmacy has been through the extension configuration.
         *
         * @param extensionId The extension id.
         */
        async markConfigured(extensionId: number): Promise<Extension> {
            // The API answers with the extension as the organization now sees
            // it — `configured` included. It is what the caller reads to know
            // whether the write landed: the API updates an existing pivot row
            // and silently does nothing when there is none.
            return client.patch(`extensions/${extensionId}/configured`)
                .then(response => response.data.data);
        }
    };
}
